import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPrivate from 'config/axiosPrivate';

export const fetchProjectManagerWriters = createAsyncThunk(
  'projectManagerUserManagement/fetchProjectManagerWriters',
  async (arg, thunkAPI) => {
    try {
      const response = await axiosPrivate.get('/user/external/global-writers');
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);